export const COLUMN_INDICATOR_ADJUSTMENT = '12px';

export const FIRST_ROWS = [1, 2, 3];

export const prependClassname = (prefix: string, className: string) => {
  if (prefix) {
    return `${prefix}-${className}`;
  }

  return className;
};
